<div [formGroup]="formGroup" class="form-group {{inline === true ? 'row inline-from-row' : ''}}">
  <label class="{{inline === true ? 'col-3' : ''}} col-form-label" *ngIf="label !== ''">{{label}}</label>
  <div [ngClass]="(inline === true ? 'col-9' : '')">
    <input type="{{inputType}}" class="form-control form-control-sm {{additionalClass}} {{error ? 'is-invalid' : ''}}"
      [formControlName]="formControlNameValue" name="{{name}}" id="{{id}}" (ngModelChange)="change()"
      placeholder="{{placeHolder}}" [required]="required" />
  </div>
  <div class="invalid-feedback {{inline === true ? 'col-12' : ''}}" [hidden]="!error">
    {{error | translate}}
  </div>
  <small class="form-text text-muted {{inline === true ? 'col-12' : ''}}" [hidden]="helpText === ''">
    {{helpText}}
  </small>
</div>